import React, { createContext, useEffect, useState } from "react";

import { apiFetch } from "../apiBindings";
import {
    storageLocal as storage,
    storageSession as session,
} from "../utils/StorageHandler";

export const DataContext = createContext();

const ElectricityDataProvider = ({ children }) => {
    const maxAmount = 100000;

    /**
     * Initialize state vars from localStorage,
     * or set default
     */

    /*
     * calculator input vars
     */
    const [zipcode, setZipcode] = useState(storage.get("ele:zipcode") || "");

    const [consumption, setConsumption] = useState(
        storage.get("ele:consumption") || 1500
    );

    const [placeSelectList, setPlaceSelectList] = useState({});
    const [placeSelectListSelected, setPlaceSelectListSelected] = useState(
        storage.get("ele:place-select-list-selected")
            ? [
                  {
                      value: storage.get("ele:place-select-list-selected"),
                      label: storage.get("ele:place-select-list-selected"),
                      value2: {
                          place: storage.get("ele:place-select-list-selected"),
                          placePart: "",
                      },
                  },
              ]
            : [{ value: "", label: "Ort", value2: "" }]
    );

    const [streetSelectList, setStreetSelectList] = useState({});
    const [streetSelectListSelected, setStreetSelectListSelected] = useState(
        storage.get("ele:street-select-list-selected")
            ? [
                  {
                      value: storage.get("ele:street-select-list-selected"),
                      label: storage.get("ele:street-select-list-selected"),
                  },
              ]
            : [{ value: "", label: "Straße", value2: "" }]
    );
    const [houseNumber, setHouseNumber] = useState(
        storage.get("ele:house-number") || ""
    );

    const [verbandsnummer, setVerbandsnummer] = useState(
        storage.get("ele:verbandsnummer") || ""
    );

    const [productChoice, setProductChoice] = useState(
        storage.get("ele:product-choice") || 1
    );

    const [tariffCode, setTariffCode] = useState("");

    const [tariffType, setTariffType] = useState(
        storage.get("ele:tariff-type") || 0
    );

    const [tariffId, setTariffId] = useState(storage.get("ele:tariff-id") || 0);

    /**
     * form Errors
     */
    const [formErrors, setFormErrors] = useState([]);
    const [result, setResult] = useState([]);
    const [loading, setLoading] = useState(false);
    const [validResult, setValidResult] = useState(false);
    const [validZipcode, setValidZipcode] = useState(true);
    const [maxConsumptionError, setMaxConsumptionError] = useState(
        consumption > maxAmount
    );

    /**
     * show inputs
     */
    const [showStreetInput, setShowStreetInput] = useState(false);
    const [showPlaceInput, setShowPlaceInput] = useState(false);
    const [showHouseNumberInput, setShowHouseNumberInput] = useState(false);

    const [networkProviderCount, setNetworkProviderCount] = useState(null);

    useEffect(() => {
        startup();
    }, []);

    /**
     * on vars change,
     * , or on new incoming GetAG data
     *
     * 1. update localStorage with storage.set()
     * or 2. do some special actions like
     *      calculateIfPossible();
     *      or syncProductInfos();
     *          => update state chosenProduct
     *          => update localstorage tariff-id
     *
     */
    useEffect(() => {
        storage.set("ele:zipcode", zipcode);
        // deprecated calculateIfPossible();
    }, [zipcode]);

    useEffect(() => {
        storage.set("ele:consumption", consumption);
    }, [consumption]);

    useEffect(() => {
        storage.set(
            "ele:street-select-list-selected",
            streetSelectListSelected[0].value
        );
    }, [streetSelectListSelected]);

    useEffect(() => {
        if (placeSelectListSelected[0].value2) {
            storage.set(
                "ele:place-select-list-selected",
                placeSelectListSelected[0].value2.place
            );
            storage.set(
                "ele:place-part-select-list-selected",
                placeSelectListSelected[0].value2.placePart
            );
        } else {
            //storage.set("ele:place-select-list-selected", "");
            //storage.set("ele:place-part-select-list-selected", "");
        }
    }, [placeSelectListSelected]);

    useEffect(() => {
        storage.set("ele:house-number", houseNumber);
    }, [houseNumber]);

    useEffect(() => {
        storage.set("ele:verbandsnummer", verbandsnummer);
    }, [verbandsnummer]);

    // on user productChoise
    useEffect(() => {
        storage.set("ele:product-choice", productChoice);
        syncProductInfos();
    }, [productChoice]);

    useEffect(() => {
        storage.set("ele:tariff-type", tariffType);
    }, [tariffType]);

    useEffect(() => {
        storage.set("ele:tariff-code", tariffCode);
    }, [tariffCode]);

    useEffect(() => {
        if (validResult && tariffId == 0 && productChoice == 0) {
            storage.set(
                "ele:tariff-id",
                Object.values(result)[productChoice].tarifID
            );
        } else if (validResult) {
            storage.set("ele:tariff-id", tariffId);
        }
    }, [tariffId, validResult]);

    // on GetAG data
    useEffect(() => {
        if (validResult) {
            syncProductInfos();
        }
    }, [result]);

    const syncProductInfos = () => {
        if (validResult) {
            const chosenProduct = Object.values(result)[productChoice];
            storage.set("ele:tariff-id", chosenProduct.tarifID);
        }
    };

    // do nothing
    const startup = async () => {
        // Here we can do some startup stuff.
    };

    /** deprecated
     * Calculate if the configuration is valid.
     const calculateIfPossible = () => {
            if (zipcode && zipcode.length === 5 && !isNaN(zipcode) && consumption > 1) {
                calculate(zipcode, consumption, place, placePart, street, houseNum, tariffType);
            }
        };
     */

    /**
     * Fetch the prices from the api and store them into the result.
     */
    const calculate = async (
        localZipcode,
        localConsumption,
        localPlace = "null",
        localPlacePart = "null",
        localStreet = "null",
        localHouseNumber = "null",
        localTariffType = 0,
        localTariffId = "",
        localdebug = 0
    ) => {
        let localNetworkProviderCount = -1;
        let localTariffCode = "null";
        if (localPlace === "") localPlace = "null";
        if (localStreet === "") localStreet = "null";
        if (localPlacePart === "") localPlacePart = "null";
        if (localStreet === "") localStreet = "null";
        if (localHouseNumber === "") localHouseNumber = "null";
        if (localTariffId === "") localTariffId = 0;
        tariffCode === ""
            ? (localTariffCode = "null")
            : (localTariffCode = tariffCode);

        if (window.location.pathname === "/strom") {
            localTariffCode = "null";
            setTariffCode("");
        }

        if (!calculatorFormValidataion()) {
            setValidResult(false);
            setLoading(false);
            setResult(null);
            return false;
        }

        if (!loading) {
            // do the calculation
            setLoading(true);

            // Prinzip
            // 0. leere alle select Listen für die Du keine Daten erhalten hast

            // empty select lists
            if (localPlace === "null") {
                setPlaceSelectList([{ value: "", label: "" }]);
                setPlaceSelectListSelected([{ value: "", label: "" }]);
                setStreetSelectList([{ value: "", label: "" }]);
                setStreetSelectListSelected([{ value: "", label: "" }]);
            }
            // empty street lists
            if (localStreet === "null") {
                setStreetSelectList([{ value: "", label: "" }]);
                setStreetSelectListSelected([{ value: "", label: "" }]);
            }

            // get networkProviderCount for zipcode
            apiFetch(
                `/getAg/electricity/getOrtsinfoExtendedPlus/${localZipcode}/${localPlace}/${localPlacePart}/${localStreet}/${localHouseNumber}/extended/false`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                }
            )
                .then((response) => response.json())
                .then((data) => {
                    if (
                        Object.keys(data).length !== 0 &&
                        data.constructor === Object &&
                        !data.exception
                    ) {
                        setNetworkProviderCount(data.stromNetzgebietLength);
                        localNetworkProviderCount = data.stromNetzgebietLength;
                        setVerbandsnummer(data.stromverbandsnummer);

                        if (localNetworkProviderCount > 1) {
                            /**
                             *  1. Frage bei gegebenen Parametern, mindestens der PLZ, wie viele Netzbetreiber es vor Ort gibt.
                             *  2. Wenn NB > 1 fülle select für die nächste Abfrage. Was die nächste Abfrage ist
                             *  entnehme den leeren funktions Eingaben Listen.
                             */
                            if (localPlace === "null") {
                                getPlacesSelect(localZipcode).then((data) => {
                                    setPlaceSelectList(data);
                                    setPlaceSelectListSelected([
                                        { value: "", label: "Bitte wählen" },
                                    ]);
                                });
                                setShowPlaceInput(true);
                            } else if (localStreet === "null") {
                                getStreetsSelect(localZipcode, localPlace).then(
                                    (data) => {
                                        setStreetSelectList(data);
                                        setStreetSelectListSelected([
                                            {
                                                value: "",
                                                label: "Bitte wählen",
                                            },
                                        ]);
                                    }
                                );
                                setShowStreetInput(true);
                            } else if (localHouseNumber === "null") {
                                setShowHouseNumberInput(true);
                            }
                        }
                    } else {
                        setValidResult(false);
                    }
                    if (
                        localNetworkProviderCount == 1 &&
                        data.stromverbandsnummer
                    ) {
                        getPrices(
                            data.stromverbandsnummer,
                            localTariffCode,
                            localZipcode,
                            localConsumption,
                            localPlace,
                            localPlacePart,
                            localStreet,
                            localHouseNumber,
                            localTariffType,
                            localTariffId,
                            localdebug
                        );
                    } else {
                        // get places
                        setValidResult(false);
                        setLoading(false);
                    }
                })
                .catch(function () {
                    setValidResult(false);
                    setLoading(false);
                });
        }
    };

    const calculatorFormValidataion = () => {
        setFormErrors([]);
        if (placeSelectListSelected[0].value === "") {
            setFormErrors(["placeSelectListSelected"]);
            return false;
        }
        if (streetSelectListSelected[0].value === "") {
            setFormErrors(["streetSelectListSelected"]);
            return false;
        }
        if (houseNumber === "") {
            setFormErrors(["houseNumber"]);
            return false;
        }

        return true;
    };

    const getPlacesSelect = async (
        localZipcode,
        enableResetValueOnReload = 1
    ) => {
        let response = await apiFetch(
            `/getAg/electricity/getOrteByPlzAsSelect/${localZipcode}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
            }
        );
        let json = await response.json();
        setPlaceSelectList(json);

        /* for later mazi
            if (json.length == 1) {
                setPlaceSelectListSelected([json[0]]);
            } else {
                setPlaceSelectListSelected([{value: "", label: "Bitte wählen"}]);
            }
            */
        if (enableResetValueOnReload == 1) {
            setPlaceSelectListSelected([{ value: "", label: "Bitte wählen" }]);
        }

        return json;
    };

    const getStreetsSelect = async (
        localZipcode,
        localPlace,
        enableResetValueOnReload = 1
    ) => {
        if (!localZipcode || !localPlace) {
            return;
        }
        let response = await apiFetch(
            `/getAg/electricity/getStrassenByPlzOrtAsSelect/${localZipcode}/${localPlace}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
            }
        );
        let json = await response.json();
        setStreetSelectList(json);
        /* for later mazi
             if (json.length == 1) {
                 setStreetSelectListSelected([json[0]]);
             } else {
                 setStreetSelectListSelected([{value: "", label: "Bitte wählen"}]);
             }
             */
        if (enableResetValueOnReload == 1) {
            setStreetSelectListSelected([{ value: "", label: "Bitte wählen" }]);
        }

        return json;
    };

    const getPrices = (
        verbandsNummer = "null",
        localTariffCode = "null",
        localZipcode,
        localConsumption,
        // eslint-disable-next-line no-unused-vars
        localPlace = "null",
        // eslint-disable-next-line no-unused-vars
        localPlacePart = "null",
        // eslint-disable-next-line no-unused-vars
        localStreet = "null",
        // eslint-disable-next-line no-unused-vars
        localHouseNumber = "null",
        localTariffType = 0,
        localTariffId = 0,
        localdebug = 0
    ) => {
        apiFetch(
            `/electricity/${localZipcode}/${localConsumption}/${localPlace}/${verbandsNummer}/${localTariffCode}/${localTariffType}/${localTariffId}/${localdebug}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
            }
        )
            .then((response) => response.json())
            .then((data) => {
                setLoading(true);
                setResult(data);

                if (data.length !== 0 && !data.exception) {
                    setValidResult(true);
                } else if (data.exception) {
                    setValidResult(false);
                }
                syncProductInfos();
                setLoading(false);
            })
            .catch(function (error) {
                setLoading(false);
                setValidResult(false);
                console.log(error);
            });
    };

    /**
     * Check if the given key is present in the errors.
     *
     * @param {*} key
     */
    const hasFormErrorAt = (key) => {
        return formErrors.filter((item) => item === key).length > 0;
    };

    /**
     * Remove an element from the errors.
     *
     * @param {*} key
     */
    const clearFormError = (key) => {
        setFormErrors(formErrors.filter((item) => item !== key));
    };

    /**
     * Returns the result object for the selected product.
     */
    const getProductWithPrices = () => {
        return result[productChoice];
    };

    /**
     * Clear the checkout before we go in the order again.
     */
    const clearCheckout = () => {
        storage.remove("ele:checkout");
        storage.remove("ele:order");
        storage.remove("ele:delivery-details");
        storage.remove("ele:delivery-address");

        session.remove("ele:checkout");
        session.remove("ele:order");
        session.remove("ele:delivery-details");
        session.remove("ele:delivery-address");
    };

    const data = {
        zipcode,
        houseNumber,
        consumption,
        tariffType,
        tariffId,
        result,
        loading,
        productChoice,
        validResult,
        validZipcode,
        networkProviderCount,
        streetSelectList,
        streetSelectListSelected,
        placeSelectList,
        placeSelectListSelected,
        showPlaceInput,
        showStreetInput,
        showHouseNumberInput,
        tariffCode,
        formErrors,
        maxAmount,
        maxConsumptionError,
    };

    const actions = {
        setLoading,
        setZipcode,
        setConsumption,
        setTariffType,
        setTariffId,
        setProductChoice,
        clearCheckout,
        calculate,
        getProductWithPrices,
        setValidResult,
        setValidZipcode,
        setShowPlaceInput,
        setShowStreetInput,
        setShowHouseNumberInput,
        setHouseNumber,
        setStreetSelectList,
        setStreetSelectListSelected,
        setPlaceSelectList,
        setPlaceSelectListSelected,
        setTariffCode,
        setVerbandsnummer,
        setResult,
        getPrices,
        clearFormError,
        getPlacesSelect,
        getStreetsSelect,
        hasFormErrorAt,
        setFormErrors,
        setMaxConsumptionError,
    };

    return (
        <DataContext.Provider
            value={{
                data,
                actions,
            }}
        >
            {children}
        </DataContext.Provider>
    );
};
export default ElectricityDataProvider;
